"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const segment_1 = require("../../utils/development/segment");
const useAuthContext_1 = __importDefault(require("../Auth/useAuthContext"));
const useFeatureFlagContext_1 = __importDefault(require("../FeatureFlag/useFeatureFlagContext"));
function useTrackContext() {
    const [ethAddress] = (0, useAuthContext_1.default)();
    const [ff] = (0, useFeatureFlagContext_1.default)();
    return (0, react_1.useCallback)((event, data, callback) => (0, segment_1.track)(event, {
        ...data,
        ethAddress,
        featureFlags: ff.list(),
    }, callback), [ethAddress, ff]);
}
exports.default = useTrackContext;
